import { doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { auth, db } from "../utils/firebase";

export default function MyInfo({ user }) {
  const { userTypeName, email, firstName, lastName, address } = user;

  const userCommunityChanger = doc(db, "Users", auth.currentUser.uid);
  const [newFirstName, setNewFirstName] = useState(firstName);
  const [newLastName, setNewLastName] = useState(lastName);
  const [newAddress, setNewAddress] = useState(address);
  const [newPhoneNumber, setNewPhoneNumber] = useState("");
  const [editing, setEditing] = useState(false);

  const updateUser = async () => {
    await updateDoc(userCommunityChanger, {
      firstName: newFirstName,
      lastName: newLastName,
      address: newAddress,
      phoneNumber: newPhoneNumber,
    });
    setNewFirstName(newFirstName);
    setNewLastName(newLastName);
    setNewAddress(newAddress);
    setNewPhoneNumber(newPhoneNumber);
  };
  return (
    <div
      id="myDetails"
      className="round-border"

    >
      {editing ? (
        <>
          <label>
            <b>First Name: </b>
          </label>
          {"  "}
          <input
            type="text"
            placeholder="First Name"
            defaultValue={newFirstName}
            onChange={(e) => setNewFirstName(e.target.value)}
            style={{ textAlign: "center" }}
          />
          <br />
          <label>
            <b>Last Name:</b>
          </label>
          {"  "}
          <input
            type="text"
            placeholder="Last Name"
            defaultValue={newLastName}
            onChange={(e) => setNewLastName(e.target.value)}
            style={{ textAlign: "center" }}
          />
          <p>
            <b>Role:</b> {userTypeName}
          </p>
          <p>
            <b>Email:</b> {email}
          </p>
          <label>
            <b>Address:</b>
          </label>
          {"  "}
          <input
            type="address"
            placeholder="Address"
            defaultValue={newAddress}
            onChange={(e) => setNewAddress(e.target.value)}
            style={{ textAlign: "center", minWidth: "350px" }}
          />
          <br />
          <label>
            <b>Phone Number</b>
          </label>
          {"  "}
          <input
            type="tel"
            placeholder="Phone Number"
            defaultValue={newPhoneNumber}
            onChange={(e) => setNewPhoneNumber(e.target.value)}
            style={{ textAlign: "center" }}
          />
          <button
            onClick={() => {
              setEditing(!editing);
              updateUser();
            }}
          >
            Done
          </button>
        </>
      ) : (
        <>
          <p>
            <b>Name:</b> {newFirstName} {newLastName}
          </p>
          <p>
            <b>Role:</b> {userTypeName}
          </p>
          <p>
            <b>Email:</b> {email}
          </p>
          <p>
            <b>Address:</b> {newAddress}
          </p>
          <p>
            <b>Phone Number: {newPhoneNumber}</b>
          </p>
          <button
            onClick={() => {
              setEditing(!editing);
            }}
          >
            Edit Info
          </button>
        </>
      )}
    </div>
  );
}
